/**
 *
 * @author arman
 * @since 10/23/17
 *
 */
import React from 'react';
import Dialog from 'material-ui/Dialog';
import config from '../../utility/app-config';
import PrescriptionForm from './prescription-form';

const styles = {
  root: {

  },
  customContentStyle: {
    width: '100%',
    height: '100%',
    maxWidth: 'none',
    maxHeight: 'none'
  },
  container: {

  },
  box: {
    overflow:'scroll',
    width : '100%',
    height:'800px'
  },
  button: {
    height: '45px',
    width: '200px'
  },
};

const PrescriptionDialog = ({open, mission, prescription, togglePrescriptionDialog, handlePrescriptionChange, submitPrescriptionForm, style, className}) => {
  // const actions = [
  //   <FlatButton
  //     label="Update"
  //     primary={true}
  //     style={styles.button}
  //     backgroundColor='#D6D6D6'
  //     onTouchTap={submitPrescriptionForm} />
  // ];

  return (
    <div className={className || 'prescription__dialog'} style={{...styles.root, ...style}}>
      <Dialog
        modal={false}
        open={open}
        autoScrollBodyContent={true}
        onRequestClose={togglePrescriptionDialog}
        contentStyle={styles.customContentStyle} >

        <div className="row">
          <div className="col-xs-12 col-sm-9 col-md-9 col-lg-9 col-md m-b-15">
            <div style={styles.box}>
              {
                prescription.file_data && prescription.file_data.map((data, ind) => (
                  <img key={ind} src={`${config.urls.doc_url}${data.s3_key}`} width='100%' alt="Prescription" />
                  ))
              }
              {
               (!prescription.file_data && prescription.s3_key) &&
                <img src={`${config.urls.doc_url}${prescription.s3_key}`} width='100%' alt="Prescription" />
              }
              {
               (!prescription.file_data && prescription.additional_s3_keys) && 
               prescription.additional_s3_keys.map((img,ind) => (                  
               <img key={ind} src={`${config.urls.doc_url}${img}`} width='100%' alt="Prescription" />
               ))
              }
            </div>
          </div>
          <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-md m-b-15">
            <PrescriptionForm
              prescription={prescription}/>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default PrescriptionDialog;


// WEBPACK FOOTER //
// ./src/screens/mission-view/prescription-dialog.component.js